import { defineComponent as _defineComponent } from 'vue'
import { useSettingsStore } from "@/pinia";
import { computed, ref } from "vue";

// computed

export default /*#__PURE__*/_defineComponent({
  __name: 'AddressExplorer',
  setup(__props) {

const getExplorerURL = computed<string>(() => {
	// return `${settingsStore.settings.explorer}/address/${address.value}`;
	return `https://explorer.solana.com/address/${address.value}`;
});

// store
const settingsStore = useSettingsStore();

// data
const channel = new BroadcastChannel("token:explorer");
const address = ref<string>("");
const renderIframe = ref<boolean>(false);
const dialogRef = ref<InstanceType<typeof HTMLDialogElement> | null>(null);

// methods
function init(): void {
	channel.onmessage = showAddress;
}
function showAddress({ data }: MessageEvent<any>): void {
	address.value = data;

	if (settingsStore.settings.explorerOpens === "tab") {
		window.open(getExplorerURL.value, "_blank");
		return;
	}

	renderIframe.value = true;
	dialogRef.value?.show();
}

// setup
init();

return { __sfc: true,getExplorerURL, settingsStore, channel, address, renderIframe, dialogRef, init, showAddress }
}

})